import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  return (
    <footer className="border-t" style={{ borderColor: 'rgba(13,27,62,0.08)', background: '#F4F6FB' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        {/* Main row */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 mb-8">
          {/* Logo + tagline */}
          <div className="flex flex-col gap-3">
            <AppLogo size={48} text="SocialBoost" iconName="BoltIcon" />
            <p className="text-sm text-[#6B7280] max-w-xs" style={{ fontFamily: 'DM Sans,sans-serif' }}>La plateforme #1 en Côte d'Ivoire pour booster vos réseaux sociaux

            </p>
            {/* Payment methods */}
            <div className="flex items-center gap-2 flex-wrap mt-1">
              <span className="momo-badge" style={{ background: '#FFF3E0', color: '#E65100' }}>Orange Money</span>
              <span className="momo-badge" style={{ background: '#E8F5E9', color: '#2E7D32' }}>MTN MoMo</span>
              <span className="momo-badge" style={{ background: '#E3F2FD', color: '#1565C0' }}>Wave</span>
            </div>
          </div>

          {/* Links */}
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            <Link href="/homepage" className="text-sm font-medium text-[#0D1B3E] hover:text-[#1877F2] transition-colors" style={{ fontFamily: 'DM Sans,sans-serif' }}>
              Accueil
            </Link>
            <Link href="/services" className="text-sm font-medium text-[#0D1B3E] hover:text-[#1877F2] transition-colors" style={{ fontFamily: 'DM Sans,sans-serif' }}>
              Services
            </Link>
            <a href="#" className="text-sm font-medium text-[#6B7280] hover:text-[#1877F2] transition-colors" style={{ fontFamily: 'DM Sans,sans-serif' }}>
              Confidentialité
            </a>
            <a href="#" className="text-sm font-medium text-[#6B7280] hover:text-[#1877F2] transition-colors" style={{ fontFamily: 'DM Sans,sans-serif' }}>
              Conditions
            </a>
          </nav>

          {/* Social */}
          <div className="flex items-center gap-3">
            <a
              href="#"
              className="w-9 h-9 rounded-xl flex items-center justify-center transition-all hover:scale-110"
              style={{ background: 'rgba(24,119,242,0.1)' }}
              aria-label="Facebook">

              <Icon name="GlobeAltIcon" size={18} className="text-[#1877F2]" />
            </a>
            <a
              href="#"
              className="w-9 h-9 rounded-xl flex items-center justify-center transition-all hover:scale-110"
              style={{ background: 'rgba(244,169,35,0.1)' }}
              aria-label="WhatsApp">

              <Icon name="ChatBubbleLeftRightIcon" size={18} className="text-[#F4A923]" />
            </a>
            <a
              href="#"
              className="w-9 h-9 rounded-xl flex items-center justify-center transition-all hover:scale-110"
              style={{ background: 'rgba(13,27,62,0.06)' }}
              aria-label="Email">

              <Icon name="EnvelopeIcon" size={18} className="text-[#0D1B3E]" />
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 border-t flex flex-col sm:flex-row items-center justify-between gap-3" style={{ borderColor: 'rgba(13,27,62,0.08)' }}>
          <p className="text-xs text-[#6B7280]" style={{ fontFamily: 'DM Sans,sans-serif' }}>
            © 2026 SocialBoost CI. Tous droits réservés. · Abidjan, Côte d'Ivoire
          </p>
          <div className="flex items-center gap-1.5">
            <span className="trust-badge text-xs">
              <Icon name="ShieldCheckIcon" size={13} className="text-[#059669]" />
              Paiement sécurisé
            </span>
          </div>
        </div>
      </div>
    </footer>);

}